import { render } from "./TestVelocidad.vue?vue&type=template&id=2dd0a0d3&scoped=true"
import script from "./TestVelocidad.vue?vue&type=script&lang=js"
export * from "./TestVelocidad.vue?vue&type=script&lang=js"

import "./TestVelocidad.vue?vue&type=style&index=0&id=2dd0a0d3&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd0a0d3"]])

export default __exports__